export default class FeedbackServiceVotesFactory {
  create() {
    const items = []
    let i = 0
    while (i <= 5) {
      items.push({
        name: i,
        id: i,
      })
      i += 0.5
    }
    return items
  }
}
